import React from 'react'
import PropTypes from 'prop-types'

const CartIcon = ({ width = 14, height = 15, color = '#fff' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_7637_53891)" fill={color}>
        <path d="M5.143 3.786c0-.26-.208-.47-.464-.47a.467.467 0 00-.465.47v1.878C4.214 7.219 5.462 8.48 7 8.48s2.786-1.26 2.786-2.816V3.786c0-.26-.208-.47-.465-.47a.467.467 0 00-.464.47v1.878A1.868 1.868 0 017 7.54a1.868 1.868 0 01-1.857-1.877V3.786z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.766.5c-1.663 0-3.08 1.225-3.29 2.877l-.95 7.511c-.25 1.974 1.307 3.696 3.29 3.696h6.369c1.982 0 3.538-1.721 3.289-3.696l-.95-7.51C12.313 1.724 10.898.5 9.233.5H4.767zM2.398 3.497c.148-1.167 1.155-2.058 2.368-2.058h4.469c1.212 0 2.22.89 2.368 2.058l.95 7.51c.176 1.39-.921 2.638-2.368 2.638h-6.37c-1.446 0-2.543-1.249-2.368-2.637l.95-7.511z"
        />
      </g>
      <defs>
        <clipPath id="clip0_7637_53891">
          <path fill="#fff" transform="translate(.5 .5)" d="M0 0H13V14.0833H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}

CartIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
}

export default React.memo(CartIcon)
